import { Link, Outlet } from 'react-router';

import { BrandLogo } from '@/components/brand/BrandLogo';
import { brand } from '@/config/brand';
import { useRouteHandle } from '@/hooks/useRouteHandle';

import { registerHeaderRightSlot } from './headerRightSlot';
import { useFoTheme } from './useFoTheme';

/**
 * FO 미니멀 레이아웃 — 슬림 헤더(로고 + 페이지라벨) + 무대(background) 본문, 푸터 없음.
 * 인증 폼·상태 결과 카드·결제 화면용. 페이지라벨은 route handle.pageLabel.
 */
export function FoMinimalLayout() {
  useFoTheme();
  const { pageLabel } = useRouteHandle();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="sticky top-0 z-header border-b bg-card/90 backdrop-blur">
        <div className="mx-auto flex h-header w-full max-w-content items-center px-4 sm:px-gutter">
          <Link to="/" className="flex items-center" aria-label={`${brand.name} 홈으로`}>
            <BrandLogo />
          </Link>
          {pageLabel && (
            <span className="ml-3.5 border-l pl-3.5 text-sm font-medium text-muted-foreground">
              {pageLabel}
            </span>
          )}
          <div ref={registerHeaderRightSlot} className="ml-auto flex items-center" />
        </div>
      </header>
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
